import React, { useState, useEffect } from 'react';
import { Snackbar, Button, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import pwaService from '@/services/pwaService';

const DISMISS_KEY = 'hfrc-pwa-install-dismissed';

export default function AppInstallBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pwaService.isInstalled()) return;
    if (localStorage.getItem(DISMISS_KEY)) return;

    const handleInstallAvailable = () => setVisible(true);
    window.addEventListener('pwaInstallAvailable', handleInstallAvailable);
    return () => window.removeEventListener('pwaInstallAvailable', handleInstallAvailable);
  }, []);

  const handleInstall = async () => {
    const accepted = await pwaService.showInstallPrompt();
    if (accepted) {
      setVisible(false);
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  return (
    <Snackbar
      open={visible}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: { xs: 8, md: 2 } }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'primary.main',
          borderRadius: 2,
          px: 2,
          py: 1.5,
          boxShadow: 6,
          maxWidth: 400,
        }}
      >
        <GetAppIcon color="primary" fontSize="small" />
        <Typography variant="body2" sx={{ flex: 1, color: 'text.primary' }}>
          Add HFRConnect to your home screen for faster access.
        </Typography>
        <Button
          size="small"
          variant="contained"
          onClick={handleInstall}
          sx={{ whiteSpace: 'nowrap', minHeight: 36 }}
        >
          Install
        </Button>
        <IconButton
          size="small"
          onClick={handleDismiss}
          aria-label="Dismiss install prompt"
          sx={{ minWidth: 36, minHeight: 36 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Snackbar>
  );
}
